import React, { useEffect, useState } from "react";
import { Divider, Dropdown, Input, Select, Spin, Tabs } from "antd";
import {
  DetailContainer,
  FormItem,
  FormikForm,
  ContentContainer,
} from "../../../StyledComponents/CreateKeyAccountManager";
import { HeadContainer } from "../../../StyledComponents/Dashboard";
import {
  DetailContent,
  DetailRow,
  LeftContent,
  MidContent,
  BottomContent,
  RightContent,
  RowValue,
  TableInput,
  TableItem,
  TDItem,
  THeadItem,
  THItem,
  Title,
  TitleDiv,
  TitleRow,
  TopButtonDiv,
  TopContent,
  TRItem,
  TableFilter,
} from "../../../StyledComponents/RateManagement";
import SubmitButton from "../Common/SubmitButton";
import { DownOutlined } from "@ant-design/icons";
import { ErrorMessage } from "formik";
import {
  move_rate_archive,
} from "../../../store/Admin/RateManagement/RateManagementSlice";
import RowSelectionTable from '../../../components/Admin/Common/RowSelectionTable'
import { useDispatch, useSelector } from "react-redux";
import {
  airlines_list,
  airport_list,
  updatenotificationdata,
} from "../../../store/Admin/Common/CommonSlice";
// import {AirlineDetailManagement}from '../../Admin/AirlineScheduleManagement/AirlineDetailManagement'
import axios from "axios";
import SelectSearchAirline from "../Common/SelectSearchAirline";
import SelectSearchPort from "../Common/SelectSearchPort";
import styled from "styled-components";
import * as Yup from "yup";
import { handleKeyPress } from "../../../functions/Utils";
import { SpinContainer } from "../../../StyledComponents/Queries";
import AddButton from "../Common/AddButton";
import { TableTab } from "../../../StyledComponents/Common";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import RadioGroups from "../Common/RadioGroups";
//import { REACT_APP_API_BASE_URL_NODE } from '../../utils/secondsToTime';
import { getairlineproduct } from "../../../store/Admin/Airlineproduct/Airlineproductslice";
import AirlineScheduleManagement from "../../../pages/Admin/AirlineScheduleManagement";
import { set } from "react-hook-form";
import config from "../../../config";
import { httpinstance } from "../../../axios/api";
import { authuser } from "../../../store/Authentication/AuthSlice";

const validationSchema = Yup.object().shape({
  carr_code: Yup.string().nullable().required("Carr Code is required"),
  destination_port: Yup.string()
    .nullable()
    .required("Destination Port is required"),
  origin_port: Yup.string().nullable().required("Origin Port is required"),
  // product: Yup.string().required("Product is required"),
  ship_type: Yup.string().nullable().required("Ship Type is required"),
  sell_min: Yup.string()
    .matches(/^[0-9]*(\.[0-9]+)?$/, "Please enter a valid number")
    .required("Sell Min is required"),
  sell_less45: Yup.string()
    .matches(/^[0-9]*(\.[0-9]+)?$/, "Please enter a valid number")
    .required("Sell Less45 is required"),
  sell_plus45: Yup.string()
    .matches(/^[0-9]*(\.[0-9]+)?$/, "Please enter a valid number")
    .required("Sell Plus45 is required"),
  sell_plus100: Yup.string()
    .matches(/^[0-9]*(\.[0-9]+)?$/, "Please enter a valid number")
    .required("Sell Plus100 is required"),
  sell_plus250: Yup.string()
    .matches(/^[0-9]*(\.[0-9]+)?$/, "Please enter a valid number")
    .when("sell_plus300", {
      is: (val) => !val || val.trim() === "",
      then: Yup.string().required(
        "Either Sell Plus250 or Sell Plus300 is required"
      ),
    }),
  sell_plus300: Yup.string().matches(
    /^[0-9]*(\.[0-9]+)?$/,
    "Please enter a valid number"
  ),
  sell_plus500: Yup.string().matches(
    /^[0-9]*(\.[0-9]+)?$/,
    "Please enter a valid number"
  ),
  sell_plus1000: Yup.string().matches(
    /^[0-9]*(\.[0-9]+)?$/,
    "Please enter a valid number"
  ),
});
const items = [
  {
    key: "1",
    label: "Option 1",
  },
  {
    key: "2",
    label: "Option 2",
  },
  {
    key: "3",
    label: "Option 3",
  },
];

const handleMenuClick = (e) => {
  console.log("Selected option:", e.key);
};

function DetailsPage(props) {
  console.log("props", props);
  const loginedUser = useSelector(authuser);
  const userroles = loginedUser?.userroles;
  const dispatch = useDispatch();
  const [spinner, setSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [numCode, setNumCode] = useState();
  const [archieve_loading, setArchiveLoading] = useState(false);
  const [type, setType] = useState(props.type);
  const [airlineproduct, setAirlineProduct] = useState([]);
//   const [detailssubtype, setDetailsSubType] = useState(1);
  const [activeButton, setActiveButton] = useState("Freight Rate");

  // const [tabType, setTabType] = useState("air");
  const [state, setState] = useState({
    airline_list: [],
    airport_list: [],
  });
  console.log(airlineproduct, state,"airlineproduct");
console.log(numCode,"numCode");
  const location = useLocation();
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {
    if (location.pathname === "/rate-management") {
      if (isLoad === false) {
        props.setPageType("table");
      } else {
        setIsLoad(false);
      }
    }
  }, [location]);

  useEffect(() => {
    console.log("type",type,props.type)
    if(props?.type ==="edit"||props?.type ==="create"&&numCode){
    const payload = numCode?numCode:props?.instance?.num_code
    dispatch(getairlineproduct(payload))
      .then((res) => {
        console.log("airlineproduct", res);
        setAirlineProduct(res?.payload?.data?.product_type);
      })
      .catch((err) => console.log(err));}

  }, [props?.type,numCode]);
  useEffect(() => {
    setState((prevState) => {
      return {
        ...prevState,
        airline_list: props?.airline_list,
        airport_list: props?.airport_list,
      };
    });
  }, [props?.airline_list, props?.airport_list]);

  // useEffect(()=>{
  //     dispatch(airlines_list())
  //     .then(res=>{
  //         // console.log('login res => ',res);
  //         if(res?.payload?.status === 200 ){
  //             setState((prevState) => {
  //                 return {
  //                     ...prevState,
  //                     airline_list: res?.payload?.data?.data
  //                 }
  //             })
  //         }
  //     })
  //     .catch(err=>{
  //         console.error(err);
  //     })

  //     dispatch(airport_list())
  //     .then(res=>{
  //         // console.log('login res => ',res);
  //         if(res?.payload?.status === 200 ){
  //             const airports = res?.payload?.data?.data
  //             const indianAirports = airports.filter(airport => airport.countryName === 'INDIA' || airport.countryName === 'India');
  //             indianAirports.sort((a, b) => a.name.localeCompare(b.name));

  //             const foreignAirports = airports.filter(airport => airport.countryName !== 'India' || airport.countryName !== 'INDIA');
  //             foreignAirports.sort((a, b) => {
  //             if (a.country === b.country) {
  //                 return a.name.localeCompare(b.name);
  //             }
  //             return a.country.localeCompare(b.country);
  //             });
  //             const sortedAirports = indianAirports.concat(foreignAirports);
  //             let resultPorts = sortedAirports.filter((obj, index, self) =>
  //                 index === self.findIndex((o) => o.code === obj.code)
  //             );
  //             setState((prevState) => {
  //                 return {
  //                     ...prevState,
  //                     airport_list: resultPorts
  //                 }
  //             })
  //             setLoading(false)
  //         }
  //     })
  //     .catch(err=>{
  //         console.error(err);
  //     })
  // },[])

  const handleCancel = (resetForm) => {
    setType("view");
    props.setType("view");
    resetForm();
  };

  const handleEdit = () => {
    setType("edit");
    props.setType("edit");
  };
  const handleSelectChange = ( value,name, setFieldValue) => {//e
    console.log(value,props?.airline_list,"hyo");
    setFieldValue([name], value);//e
    const selectedAirline = props?.airline_list?.find(airline => airline?.carr_code === value);
    console.log(value,selectedAirline,"hiiiiiiii");
    if (selectedAirline) {
      setNumCode(selectedAirline?.num_code); // Update num_code based on selected carr_code
    } else {
      setNumCode(""); // Reset num_code if no match found
    }
    // console.log(e,name,setFieldValue);;
  };
  

  const handleArchive = () => {
    setArchiveLoading(true);
    let rate_id = props.instance._id;
    const values = {
      rate_id: rate_id,
      customType: "Air",
    };
    dispatch(move_rate_archive(values))
      .then((res) => {
        if (res?.payload?.data?.statusCode === 200) {
          //   console.log(res?.payload?.data?.data);
          dispatch(updatenotificationdata(res?.payload?.data));
          setArchiveLoading(false);
          props.setPageType("table");
          props.setCallList(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const initialValues = {
    airline: props.instance?.airline ? props.instance?.airline : "",
    destination_port: props.instance?.destination_port
      ? props.instance?.destination_port
      : null,
    origin_port: props.instance?.origin_port
      ? props.instance?.origin_port
      : null,
    carr_code: props.instance?.carr_code ? props.instance?.carr_code : null,
    num_code: props.instance?.num_code ? props.instance?.num_code : null,
    product: props.instance?.product ? props.instance?.product : "",
    ship_type: props.instance?.ship_type ? props.instance?.ship_type : null,
    pub_minimum: props.instance?.pub_minimum ? props.instance?.pub_minimum : "",
    sell_min: props.instance?.sell_min ? props.instance?.sell_min : "",
    buy_min: props.instance?.buy_min ? props.instance?.buy_min : "",
    pub_less45: props.instance?.pub_less45 ? props.instance?.pub_less45 : "",
    pub_plus45: props.instance?.pub_plus45 ? props.instance?.pub_plus45 : "",
    sell_less45: props.instance?.sell_less45 ? props.instance?.sell_less45 : "",
    buy_less45: props.instance?.buy_less45 ? props.instance?.buy_less45 : "",
    buy_plus45: props.instance?.buy_plus45 ? props.instance?.buy_plus45 : "",
    sell_plus45: props.instance?.sell_plus45 ? props.instance?.sell_plus45 : "",
    pub_plus100: props.instance?.pub_plus100 ? props.instance?.pub_plus100 : "",
    sell_plus100: props.instance?.sell_plus100
      ? props.instance?.sell_plus100
      : "",
    buy_plus100: props.instance?.buy_plus100 ? props.instance?.buy_plus100 : "",
    pub_plus250: props.instance?.pub_plus250 ? props.instance?.pub_plus250 : "",
    sell_plus250: props.instance?.sell_plus250
      ? props.instance?.sell_plus250
      : "",
    buy_plus250: props.instance?.buy_plus250 ? props.instance?.buy_plus250 : "",
    pub_plus300: props.instance?.pub_plus300 ? props.instance?.pub_plus300 : "",
    sell_plus300: props.instance?.sell_plus300
      ? props.instance?.sell_plus300
      : "",
    buy_plus300: props.instance?.buy_plus300 ? props.instance?.buy_plus300 : "",
    pub_plus500: props.instance?.pub_plus500 ? props.instance?.pub_plus500 : "",
    sell_plus500: props.instance?.sell_plus500
      ? props.instance?.sell_plus500
      : "",
    buy_plus500: props.instance?.buy_plus500 ? props.instance?.buy_plus500 : "",
    pub_plus1000: props.instance?.pub_plus1000
      ? props.instance?.pub_plus1000
      : "",
    sell_plus1000: props.instance?.sell_plus1000
      ? props.instance?.sell_plus1000
      : "",
    buy_plus1000: props.instance?.buy_plus1000
      ? props.instance?.buy_plus1000
      : "",
    fsc_minimum: props.instance?.fsc_minimum ? props.instance?.fsc_minimum : "",
    fsc_minimum_terms: props.instance?.fsc_minimum_terms
      ? props.instance?.fsc_minimum_terms
      : "",
    fsc_normal: props.instance?.fsc_normal ? props.instance?.fsc_normal : "",
    fsc_normal_terms: props.instance?.fsc_normal_terms
      ? props.instance?.fsc_normal_terms
      : "",
    ssc: props.instance?.ssc ? props.instance?.ssc : "",
    xray: props.instance?.xray ? props.instance?.xray : "",
    misc: props.instance?.misc ? props.instance?.misc : "",
    ctg: props.instance?.ctg ? props.instance?.ctg : "",
    ams: props.instance?.ams ? props.instance?.ams : "",
    others: props.instance?.others ? props.instance?.others : "",
    customType: "Air",
    id: props.instance?._id ? props.instance?._id : "",
  };

  const carr_code_list = state.airline_list.filter((obj, index, self) => {
    return index === self.findIndex((t) => t.carr_code === obj.carr_code);
  });

  const ship_types = [
    {
      value: "General",
      name: "General",
    },
    {
      value: "Special",
      name: "Special",
    },
    {
      value: "Dangerous Goods",
      name: "Dangerous Goods",
    },
    {
      value: "Temperature Controlled/Pharma",
      name: "Temperature Controlled/Pharma",
    },
    {
      value: "Other Special Commodity",
      name: "Other Special Commodity",
    },
  ];
  const handlenumcodechange= (numcode)=>{
    console.log(numcode,"handlenumcode ")
    setNumCode(numcode)
// console.log(e.target.value);
  }
  console.log(numCode,"numCode");
//   const columns = [
//     {
//       title: "AIRLINE",
//       dataIndex: "airlineName",
//     },
//     {
//       title: "Origin",
//       dataIndex: "origin",
//       render: (text, record, index) => {
//         return text ? text?.split("-")?.[1]?.replace(/[()]/g, "") : "-";
//       },
//     },
//     {
//       title: "Desination",
//       dataIndex: "destination",
//       render: (text, record, index) => {
//         return text ? text?.split("-")?.[1]?.replace(/[()]/g, "") : "-";
//       },
//     },
//     {
//       title: "Departure Days",
//       dataIndex: "departuredays",
//       render: (text, record, index) => {
//         return text ? text?.map((item) => item?.toUpperCase()).join(",") : "-";
//       },
//     },
//     {
//       title: "Departure Time",
//       dataIndex: "departureTime",
//       render: (text, record, index) => {
//         return text ? dayjs(text).format("HH:mm") : "-";
//       },
//     },
//     {
//       title: "Routing",
//       dataIndex: "itinerary",
//       render: (text, record, index) => {
//         return text?.length === 1 ? "Direct" : multiwayFlight(text);
//       },
//     },
//     {
//       title: "LAT",
//       dataIndex: "lat",
//     },
//     {
//       title: "TAO",
//       dataIndex: "tao",
//     },
//     {
//       title: "ACTION",
//       dataIndex: "action",
//       className: "text-right",
//       render: (text, record, index) => {
//         return (
//           <Space>
//             <ViewButton handleClick={() => handleView(record)} data={record} />
//             {/* <DeleteOutlined
//               onClick={() => handleDeleteRecord(record)}
//               style={{ cursor: "pointer", color: "red" }}
//             /> */}
//           </Space>
//         );
//       },
//     },
//   ];
  if (loading) {
    return (
      <SpinContainer className="user-quote">
        <Spin />
      </SpinContainer>
    );
  } else {
    return (
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          console.log(values);
          setSpinner(true);
          if (type === "edit") {
            
            try {
              const result = await httpinstance.put(
                // `https://dev.sgate-search.2.mtlstaging.com/query/update/${values.id}`,
                `update/${values.id}`,
                values
              );
              if (result.status === 200) {
                let data = {
                  message: result.data.message,
                  statusCode: 200,
                  success: result.data.success,
                };
                dispatch(updatenotificationdata(data));
                setSpinner(false);
                // resetForm()
                props.setCallList(true);
                props.setPageType("table");
              }
            } catch (error) {
              console.log(error);
              setSpinner(false);
            }


            // const payload =props?.instance?.num_code?props?.instance?.num_code:numCode
            // dispatch(getairlineproduct(payload))
            //   .then((res) => {
            //     console.log("airlineproduct", res);
            //     setAirlineProduct(res?.payload?.data?.product_type);
            //   })
            //   .catch((err) => console.log(err))
        // console.log("valuesONCHANGE ", values);
          } else {
            try {
              const result = await httpinstance.post(
                // "https://dev.sgate-search.2.mtlstaging.com/query/manual",
                "manual",
                values
              );
              if (result.status === 200) {
                let data = {
                  message: result.data.message,
                  statusCode: 200,
                  success: result.data.status,
                };
                dispatch(updatenotificationdata(data));
                setSpinner(false);
                resetForm();
                props.setCallList(true);
                props.setPageType("table");
              }
            } catch (error) {
              console.log(error);
              setSpinner(false);
            }
          }
        }}
      >
        {({ values, setFieldValue, handleChange, handleBlur, resetForm }) => (
          <FormItem>
            <DetailContainer>
              <HeadContainer>
                <TableFilter>
                  <>
                    <div className="flex justify-center items-center">
                      <TableTab
                        className="first"
                        active={props.tabType === "air"}
                        onClick={() => props.setTabType("air")}
                      >
                        Air
                      </TableTab>
                      <Button
        onClick={() =>{ setActiveButton("Freight Rate")}}
        sx={{
          color: activeButton === "Freight Rate" ? "#000" : "#fff",
          backgroundColor: activeButton === "Freight Rate" ? "#FFAF00" : "gray",
          border: "1px solid black",
          margin: "10px",
          padding: "5px",
          paddingLeft: "10px",
          paddingRight: "10px",
          "&:hover": {
            backgroundColor: activeButton === "Freight Rate" ? "#FFAF00" : "gray",
            color: activeButton === "Freight Rate" ? "#000" : "#fff",
          },
        }}
      >
        Freight Rate
      </Button>

      <Button
        onClick={() => setActiveButton("Flight Schedule")}
        sx={{
          color: activeButton === "Flight Schedule" ? "#000" : "#fff",
          backgroundColor: activeButton === "Flight Schedule" ? "#FFAF00" : "gray",
          border: "1px solid black",
          margin: "10px",
          padding: "5px",
          paddingLeft: "10px",
          paddingRight: "10px",
          "&:hover": {
            backgroundColor: activeButton === "Flight Schedule" ? "#FFAF00" : "gray",
            color: activeButton === "Flight Schedule" ? "#000" : "#fff",
          },
        }}
      >
        Flight Schedule
      </Button>
                    </div>

                    {/* {type === 'create'? 
                            <>
                                <Divider type="vertical" />
                                <TableTab active={props.tabType === 'ocean'} onClick={()=> props.setTabType('ocean')}>Ocean</TableTab>
                            </>
                        : null} */}
                  </>
                  {/* removed sub radiobutton */}
                  {/* <TableFilter className='mb-2'>
                            <RadioGroups datas={props.sub_filter} value={props.subTabType} handleClick={Object.keys(props.instance).length === 0 ? props.handleRadioClick : null} name="air" />
                        </TableFilter> */}
                </TableFilter>
                {/* <Title>Air</Title> */}
              { activeButton ==="Freight Rate"&& (
                <TopButtonDiv className="mb-3">
                  {/* archivebutton removed */}
                  {/* {type === 'view'?
                                <AddButton title="Move To Archive" icon_type="archive" handleClick={()=> handleArchive()} loading={archieve_loading} />
                            : null} */}
                  {type === "edit" || type === "create" ? (
                    <>
                      {" "}
                      {type === "edit" ? (
                        <SubmitButton
                          type="button"
                          title="Cancel"
                          is_icon={false}
                          handleClick={() => handleCancel(resetForm)}
                        />
                      ) : null}
                      <SubmitButton
                        type="submit"
                        title="save"
                        is_save={true}
                        loading={spinner}
                      />
                    </>
                  ) : (
                    <SubmitButton
                      type="button"
                      title="Edit"
                      icon_type="edit"
                      handleClick={() => handleEdit()}
                    />
                  )}
                </TopButtonDiv>)}
              </HeadContainer>
              {activeButton ==="Freight Rate"?(<ContentContainer>
                <TopContent>
                  <LeftContent>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Carr Code*</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <SelectSearchAirline
                            name="carr_code"
                            value={values.carr_code}
                            setFieldValue={setFieldValue}
                            options={carr_code_list}
                            width="100%"
                            // {props?.type === "edit" && "disabled" }
                            radius="8px"
                            placeholder="Carr Code"
                            onChange={(value) => handleSelectChange(value, "carr_code", setFieldValue)} 
                          />
                          <ErrorMessage
                            name="carr_code"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.carr_code}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Origin Airport*</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <SelectSearchPort
                            name="origin_port"
                            setFieldValue={setFieldValue}
                            value={values.origin_port}
                            options={state.airport_list}
                            width="100%"
                            bradius="8px"
                            placeholder="Origin Airort"
                          />
                          <ErrorMessage
                            name="origin_port"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.origin_port}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Product*</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          {/* <Input
                                    id="product"
                                    name="product"
                                    value={values.product}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Product'
                                /> */}
                          <ItemSelect
                            size="large"
                            id="product"
                            name="product"
                            placeholder="product"
                            style={{
                              width: "100%",
                            }}
                            onChange={(value) =>
                              handleSelectChange(value, "product", setFieldValue)
                            }
                            options={airlineproduct?.map((item) => ({
                              value: item?.product_type,
                              label: item?.product_type,
                            }))}
                            value={values.product}
                          />

                          <ErrorMessage
                            name="product"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue className="raw-width">
                          {values.product}
                        </RowValue>
                      )}
                    </DetailRow>
                  </LeftContent>
                  <LeftContent>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Num Code</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          {/* <SelectSearchAirline name="num_code" value={values.num_code} setFieldValue={setFieldValue} options={state.airline_list?.filter((i)=> i.carr_code === values.carr_code)} 
                                width="100%" bradius="8px" placeholder="Num Code" /> */}
                          <Input
                            id="num_code"
                            name="num_code"
                            value={values.num_code}
                            onBlur={handleBlur}
                            onChange={handlenumcodechange(values.num_code)}
                            size="large"
                            placeholder="Num Code"
                            disabled
                          />
                          <ErrorMessage
                            name="num_code"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.num_code}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Destination Airport*</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <SelectSearchPort
                            name="destination_port"
                            setFieldValue={setFieldValue}
                            value={values.destination_port}
                            options={state.airport_list}
                            width="100%"
                            bradius="8px"
                            placeholder="Destination Airort"
                          />
                          <ErrorMessage
                            name="destination_port"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.destination_port}</RowValue>
                      )}
                    </DetailRow>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Ship Type*</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          {/* <Input
                                    id="ship_type"
                                    name="ship_type"
                                    value={values.ship_type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Ship Type'
                                /> */}
                          <ItemSelect
                            size="large"
                            id="ship_type"
                            name="ship_type"
                            placeholder="Ship Type"
                            style={{
                              width: "100%",
                            }}
                            onChange={(value) =>
                              handleSelectChange(value, "ship_type", setFieldValue)
                            }
                            options={ship_types}
                            value={values.ship_type}
                          />
                          <ErrorMessage
                            name="ship_type"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        <RowValue>{values.ship_type}</RowValue>
                      )}
                    </DetailRow>
                  </LeftContent>
                  <RightContent>
                    <DetailRow>
                      <TitleDiv>
                        <TitleRow>Airline</TitleRow>
                      </TitleDiv>
                      {type === "edit" || type === "create" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                          }}
                        >
                          <Input
                            id="airline"
                            name="airline"
                            // value={state.airline_list?.filter((i)=> i.carr_code === values.carr_code && i.num_carr_code === values.num_code)[0]?.carr_name}
                            value={values.airline}
                            onBlur={handleBlur}
                            size="large"
                            placeholder="Airline"
                            disabled
                          />
                          <ErrorMessage
                            name="airline"
                            component="div"
                            style={{ color: "red", fontSize: "12px" }}
                          />
                        </div>
                      ) : (
                        // <RowValue>{state.airline_list?.filter((i)=> i.carr_code === values.carr_code && i.num_carr_code === values.num_code)[0]?.carr_name}</RowValue> }
                        <RowValue>{values.airline}</RowValue>
                      )}
                    </DetailRow>
                  </RightContent>
                </TopContent>
                <MidContent className="pb-8">
                  <TableItem>
                    <THeadItem>
                      <TRItem>
                        <THItem></THItem>
                        <THItem>Min</THItem>
                        <THItem>Less 45</THItem>
                        <THItem>Plus 45</THItem>
                        <THItem>Plus 100</THItem>
                        <THItem>Plus 250</THItem>
                        <THItem>Plus 300</THItem>
                        <THItem>Plus 500</THItem>
                        <THItem>Plus 1000</THItem>
                      </TRItem>
                    </THeadItem>
                    <tbody>
                      {/* <TRItem>
                            <THItem className={type}>Buy</THItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_min"
                                            name="buy_min"
                                            value={values.buy_min}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Minimum'
                                        />
                                        <ErrorMessage name="buy_min" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_min}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_less45"
                                            name="buy_less45"
                                            value={values.buy_less45}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Less 45'
                                        />
                                        <ErrorMessage name="buy_less45" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_less45}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_plus45"
                                            name="buy_plus45"
                                            value={values.buy_plus45}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Plus 45'
                                        />
                                        <ErrorMessage name="buy_plus45" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_plus45}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_plus100"
                                            name="buy_plus100"
                                            value={values.buy_plus100}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Plus100'
                                        />
                                        <ErrorMessage name="buy_plus100" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_plus100}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_plus250"
                                            name="buy_plus250"
                                            value={values.buy_plus250}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Plus250'
                                        />
                                        <ErrorMessage name="buy_plus250" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_plus250}</RowValue>}
                            </TDItem>
                            
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_plus300"
                                            name="buy_plus300"
                                            value={values.buy_plus300}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Plus300'
                                        />
                                        <ErrorMessage name="buy_plus300" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_plus300}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_plus500"
                                            name="buy_plus500"
                                            value={values.buy_plus500}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Plus500'
                                        />
                                        <ErrorMessage name="buy_plus500" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_plus500}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="buy_plus1000"
                                            name="buy_plus1000"
                                            value={values.buy_plus1000}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Buy Plus1000'
                                        />
                                        <ErrorMessage name="buy_plus1000" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.buy_plus1000}</RowValue>}
                            </TDItem>
                        </TRItem> */}
                      <TRItem>
                        <THItem>Sell</THItem>
                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_min"
                                name="sell_min"
                                value={values.sell_min}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Minimum"
                              />
                              <ErrorMessage
                                name="sell_min"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_min}</RowValue>
                          )}
                        </TDItem>
                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_less45"
                                name="sell_less45"
                                value={values.sell_less45}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Less 45"
                              />
                              <ErrorMessage
                                name="sell_less45"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_less45}</RowValue>
                          )}
                        </TDItem>

                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_plus45"
                                name="sell_plus45"
                                value={values.sell_plus45}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Plus 45"
                              />
                              <ErrorMessage
                                name="sell_plus45"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_plus45}</RowValue>
                          )}
                        </TDItem>
                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_plus100"
                                name="sell_plus100"
                                value={values.sell_plus100}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Plus100"
                              />
                              <ErrorMessage
                                name="sell_plus100"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_plus100}</RowValue>
                          )}
                        </TDItem>
                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_plus250"
                                name="sell_plus250"
                                value={values.sell_plus250}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Plus250"
                              />
                              <ErrorMessage
                                name="sell_plus250"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_plus250}</RowValue>
                          )}
                        </TDItem>
                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_plus300"
                                name="sell_plus300"
                                value={values.sell_plus300}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Plus300"
                              />
                              <ErrorMessage
                                name="sell_plus300"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_plus300}</RowValue>
                          )}
                        </TDItem>
                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_plus500"
                                name="sell_plus500"
                                value={values.sell_plus500}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Plus500"
                              />
                              <ErrorMessage
                                name="sell_plus500"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_plus500}</RowValue>
                          )}
                        </TDItem>
                        <TDItem>
                          {type === "edit" || type === "create" ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <TableInput
                                id="sell_plus1000"
                                name="sell_plus1000"
                                value={values.sell_plus1000}
                                onKeyPress={handleKeyPress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder="Sell Plus1000"
                              />
                              <ErrorMessage
                                name="sell_plus1000"
                                component="div"
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          ) : (
                            <RowValue>{values.sell_plus1000}</RowValue>
                          )}
                        </TDItem>
                      </TRItem>

                      {/* <TRItem>
                            <THItem>Pub</THItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_minimum"
                                            name="pub_minimum"
                                            value={values.pub_minimum}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Minimum'
                                        />
                                        <ErrorMessage name="pub_minimum" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_minimum}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_less45"
                                            name="pub_less45"
                                            value={values.pub_less45}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Less 45'
                                        />
                                        <ErrorMessage name="pub_less45" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_less45}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_plus45"
                                            name="pub_plus45"
                                            value={values.pub_plus45}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Plus 45'
                                        />
                                        <ErrorMessage name="pub_plus45" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_plus45}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_plus100"
                                            name="pub_plus100"
                                            value={values.pub_plus100}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Plus 100'
                                        />
                                        <ErrorMessage name="pub_plus100" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_plus100}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_plus250"
                                            name="pub_plus250"
                                            value={values.pub_plus250}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Plus 250'
                                        />
                                        <ErrorMessage name="pub_plus250" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_plus250}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_plus300"
                                            name="pub_plus300"
                                            value={values.pub_plus300}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Plus 300'
                                        />
                                        <ErrorMessage name="pub_plus300" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_plus300}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_plus500"
                                            name="pub_plus500"
                                            value={values.pub_plus500}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Plus 500'
                                        />
                                        <ErrorMessage name="pub_plus500" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_plus500}</RowValue>}
                            </TDItem>
                            <TDItem>
                                {type === 'edit' || type === 'create' ? 
                                    <div style={{ display: 'flex',flexDirection: 'column', width: '100%'}}>
                                        <TableInput
                                            id="pub_plus1000"
                                            name="pub_plus1000"
                                            value={values.pub_plus1000}
                                            onKeyPress={handleKeyPress}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            size="large"
                                            placeholder='Pub Plus 1000'
                                        />
                                        <ErrorMessage name="pub_plus1000" component="div" style={{ color: 'red',fontSize: '12px' }} />
                                    </div>
                                :
                                <RowValue>{values.pub_plus1000}</RowValue>}
                            </TDItem>
                        </TRItem> */}
                    </tbody>
                  </TableItem>
                </MidContent>
              </ContentContainer>):
              (<AirlineScheduleManagement activeButton={activeButton}  data={props?.instance} />)
            //   <ContentContainer>
            //     <RowSelectionTable />
            //     {/* rowKey="id" currentPage={currentPage} pageSize={pageSize}  setSelectArchive={setSelectArchive} checkedValues={selectedArchives}  */}
            //     </ContentContainer>
                }
              {/* <TitleRow className='sub-head mt-10'>Surcharges</TitleRow>
                <BottomContent>
                    <LeftContent>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>FSC Minimum</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="fsc_minimum"
                                    name="fsc_minimum"
                                    value={values.fsc_minimum}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='FSC Minimum'
                                />
                                <ErrorMessage name="fsc_minimum" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.fsc_minimum}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>SSC</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="ssc"
                                    name="ssc"
                                    value={values.ssc}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='SSC'
                                />
                                <ErrorMessage name="ssc" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.ssc}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>AMS</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="ams"
                                    name="ams"
                                    value={values.ams}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='AMS'
                                />
                                <ErrorMessage name="ams" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.ams}</RowValue> }
                        </DetailRow>
                    </LeftContent>
                    <LeftContent>
                    <DetailRow>
                        <TitleDiv>
                            <TitleRow>FSC Minimum Terms</TitleRow>
                        </TitleDiv>
                        {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                            <Input
                                id="fsc_minimum_terms"
                                name="fsc_minimum_terms"
                                value={values.fsc_minimum_terms}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder='FSC Minimum Terms'
                            />
                            <ErrorMessage name="fsc_minimum_terms" component="div" style={{ color: 'red',fontSize: '12px' }} />
                        </div>
                        :
                        <RowValue>{values.fsc_minimum_terms}</RowValue> }
                    </DetailRow>
                    <DetailRow>
                        <TitleDiv>
                            <TitleRow>XRAY</TitleRow>
                        </TitleDiv>
                        {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                            <Input
                                id="xray"
                                name="xray"
                                value={values.xray}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder='XRAY'
                            />
                            <ErrorMessage name="xray" component="div" style={{ color: 'red',fontSize: '12px' }} />
                        </div>
                        :
                        <RowValue>{values.xray}</RowValue> }
                    </DetailRow>
                    <DetailRow>
                        <TitleDiv>
                            <TitleRow>Others</TitleRow>
                        </TitleDiv>
                        {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                            <Input
                                id="others"
                                name="others"
                                value={values.others}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                size="large"
                                placeholder='Others'
                            />
                            <ErrorMessage name="others" component="div" style={{ color: 'red',fontSize: '12px' }} />
                        </div>
                        :
                        <RowValue>{values.others}</RowValue> }
                    </DetailRow>
                    </LeftContent>
                    <LeftContent>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>FSC Normal</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="fsc_normal"
                                    name="fsc_normal"
                                    value={values.fsc_normal}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='FSC Normal'
                                />
                                <ErrorMessage name="fsc_normal" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.fsc_normal}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>MISC</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                                <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="misc"
                                    name="misc"
                                    value={values.misc}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='misc'
                                />
                                <ErrorMessage name="misc" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.misc}</RowValue> }
                        </DetailRow>
                        <DetailRow style={{marginBottom: '53px'}}></DetailRow>
                    </LeftContent>
                    <RightContent>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>FSC Normal Terms</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="fsc_normal_terms"
                                    name="fsc_normal_terms"
                                    value={values.fsc_normal_terms}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='FSC Normal Terms'
                                />
                                <ErrorMessage name="fsc_normal_terms" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.fsc_normal_terms}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>CTG</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="ctg"
                                    name="ctg"
                                    value={values.ctg}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='CTG'
                                />
                                <ErrorMessage name="ctg" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.ctg}</RowValue> }
                        </DetailRow>
                        <DetailRow style={{marginBottom: '53px'}}>
                        </DetailRow>
                    </RightContent>
                </BottomContent> */}
            </DetailContainer>
          </FormItem>
        )}
      </FormikForm>
    );
  }
}

export default DetailsPage;

const ItemSelect = styled(Select)`
  & .ant-select-selector {
    border-radius: 8px !important;
    padding: ${({ pdg }) => (pdg ? pdg : "unset")};
  }
  & .ant-select-selection-placeholder {
    color: #d9d9d9 !important;
    font-size: 16px;
    font-weight: 400;
  }
  & .ant-select-arrow {
    color: #d9d9d9 !important;
  }
  /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`;
